/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// Lesson Templates
import IntroductionVideo from './lesson/IntroductionVideo';
import Objectives from './lesson/Objectives';
import SceneSetter from './lesson/SceneSetter';
import TerminologyReview from './lesson/TerminologyReview';
import Reading from './lesson/Reading';
import Listening from './lesson/Listening';
import MultipleChoice from './lesson/MultipleChoice';
import ConceptCategorizing from './lesson/ConceptCategorizing';
import ErrorIdentification from './lesson/ErrorIdentification';
import SummaryEvaluation from './lesson/SummaryEvaluation';
import LinguisticEvaluation from './lesson/LinguisticEvaluation';
import RegisterAnalysis from './lesson/RegisterAnalysis';
import LessonSummary from './lesson/LessonSummary';
import ModuleSummary from './lesson/ModuleSummary';
import Enrichment from './lesson/Enrichment';
// PE Templates
import PETransition from './practicalexercise/PETransition';
import MissionSelection from './practicalexercise/MissionSelection';
import ScenarioBrief from './practicalexercise/ScenarioBrief';
import PEEnvironmentBase from './practicalexercise/PEEnvironmentBase';
// Environment Home
// Environment Path
import PEReadingAuthenticMaterial from './practicalexercise/PEReadingAuthenticMaterial';
import PEInteractiveListening from './practicalexercise/PEInteractiveListening';
import PEReferenceReading from './practicalexercise/PEReferenceReading';
import PEReferenceListening from './practicalexercise/PEReferenceListening';
import PEMultipleChoice from './practicalexercise/PEMultipleChoice';
import PEConceptComprehension from './practicalexercise/PEConceptComprehension';
import PEEmentorObject from './practicalexercise/PEEmentorObject';
import PEInformativeEvent from './practicalexercise/PEInformativeEvent';
import PEDecisionEvent from './practicalexercise/PEDecisionEvent';
import PEObservationEvent from './practicalexercise/PEObservationEvent';
import PEDialogInteraction from './practicalexercise/PEDialogInteraction';
import PEPhoneCallInteraction from './practicalexercise/PEPhoneCallInteraction';
import PEFaceToFaceInteraction from './practicalexercise/PEFaceToFaceInteraction';
import PECompletionEvent from './practicalexercise/PECompletionEvent';
import ConstructedResponse from './practicalexercise/ConstructedResponse';
import PEConstructedDraftReport from './practicalexercise/PEConstructedDraftReport';
import PECapstoneHypothesisResponse from './practicalexercise/PECapstoneHypothesisResponse';
import PECapstonePresentationBrief from './practicalexercise/PECapstonePresentationBrief';
import PEArgumentCounterArgument from './practicalexercise/PEArgumentCounterArgument';
import PECapstoneWhitePaper from './practicalexercise/PECapstoneWhitePaper';
import NoteCards from './practicalexercise/NoteCards';
import PECapstoneOpEdPaper from './practicalexercise/PECapstoneOpEdPaper';
import FPECapstoneResponse from './practicalexercise/FPECapstoneResponse';
import PEDebrief from './practicalexercise/PEDebrief';
// Assessment Templates
import AssessmentIntroductionScreen from './assessment/AssessmentIntroductionScreen';
import AssessmentReadingMultipleChoice from './assessment/AssessmentReadingMultipleChoice';
import AssessmentListeningMultipleChoice from './assessment/AssessmentListeningMultipleChoice';
import AssessmentSummaryScreen from './assessment/AssessmentSummaryScreen';
// Introductory Templates
import IntroCarousel from './introduction/IntroCarousel';
import TutorialVideo from './introduction/TutorialVideo';
import IntroSummary from './introduction/IntroSummary';
import FPEEnvironmentHome from './practicalexercise/FPEEnvironmentHome';
import FPEEnvironmentPath from './practicalexercise/FPEEnvironmentPath';

const formComponents = {
  // Lesson Templates
  TMPL001: IntroductionVideo,
  TMPL002: Objectives,
  TMPL003: SceneSetter,
  TMPL004: TerminologyReview,
  TMPL005: Reading,
  TMPL006: Listening,
  TMPL007: MultipleChoice,
  TMPL008: ConceptCategorizing,
  TMPL009: ErrorIdentification,
  TMPL010: SummaryEvaluation,
  TMPL011: LinguisticEvaluation,
  TMPL012: RegisterAnalysis,
  TMPL013: LessonSummary,
  TMPL014: ModuleSummary,
  TMPL015: Enrichment,
  // PE Templates
  TMPPE001: PETransition,
  TMPPE002: MissionSelection,
  TMPPE003: ScenarioBrief,
  TMPPE004: PEEnvironmentBase,
  TMPPE005: FPEEnvironmentHome, // Environment Home
  TMPPE006: FPEEnvironmentPath, // Environment Path
  TMPPE007: PEReadingAuthenticMaterial,
  TMPPE008: PEInteractiveListening,
  TMPPE009: PEReferenceReading,
  TMPPE010: PEReferenceListening,
  TMPPE011: PEMultipleChoice, // Multiple Choice
  TMPPE012: PEConceptComprehension,
  TMPPE013: PEEmentorObject, // Supplemental Content
  TMPPE014: PEInformativeEvent,
  TMPPE015: PEDecisionEvent,
  TMPPE016: PEObservationEvent, // Observation Event
  TMPPE017: PEDialogInteraction,
  TMPPE018: PEPhoneCallInteraction,
  TMPPE019: PEFaceToFaceInteraction,
  TMPPE020: PECompletionEvent, // Feedback Event
  TMPPE021: ConstructedResponse,
  TMPPE022: PEConstructedDraftReport,
  TMPPE023: PECapstoneHypothesisResponse,
  TMPPE024: PECapstonePresentationBrief,
  TMPPE025: PEArgumentCounterArgument,
  TMPPE026: PECapstoneWhitePaper,
  TMPPE027: NoteCards,
  TMPPE028: PECapstoneOpEdPaper,
  TMPPE029: FPECapstoneResponse, // FPE Capstone Report
  TMPPE030: PEDebrief,
  // Assessment Templates
  TMPA001: AssessmentIntroductionScreen,
  TMPA002: AssessmentReadingMultipleChoice,
  TMPA003: AssessmentListeningMultipleChoice,
  TMPA004: AssessmentSummaryScreen,
  // Introductory Templates
  TMPI001: IntroCarousel,
  TMPI002: TutorialVideo,
  TMPI003: IntroSummary
};

export default formComponents;
